"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPhotoModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const react_dropzone_1 = require("react-dropzone");
const react_avatar_editor_1 = __importDefault(require("react-avatar-editor"));
const RemovePhotoTrashIcon_1 = require("../../assets/icons/RemovePhotoTrashIcon");
const ZoomInIcon_1 = require("../../assets/icons/ZoomInIcon");
const ZoomOutIcon_1 = require("../../assets/icons/ZoomOutIcon");
const useLocale_1 = require("../../hooks/useLocale/useLocale");
const useDropzoneHelpers_1 = require("../dropzone/useDropzoneHelpers/useDropzoneHelpers");
const messages_1 = require("../../core/i18n/messages");
const global_variables_1 = require("../../core/global.variables");
const Modal_1 = require("../modal/Modal");
const Styled = __importStar(require("./AddPhotoModal.styles"));
const MAX_FILE_SIZE_BYTES = 10000000;
const MIN_SCALE = 0.1;
const MAX_SCALE = 3;
const STEP_SCALE = 0.01;
const DEFAULT_DROPZONE_WIDTH = 284;
const DEFAULT_DROPZONE_HEIGHT = 284;
const AddPhotoModal = ({ onClose, open, onSubmit, clearOnClose, modalTitle, submitButtonText, maxPhotoDimensions, dropzoneDimensions, dropzoneDescription, errorAlignedLeft = false, }) => {
    const { formatMessage } = (0, useLocale_1.useLocale)();
    const { getFilesWithResolution, customImageRsolutionValidation } = (0, useDropzoneHelpers_1.useDropzoneHelpers)();
    const editor = (0, react_1.useRef)(null);
    const [file, setFile] = (0, react_1.useState)(undefined);
    const [scale, setScale] = (0, react_1.useState)(1);
    const onDrop = (0, react_1.useCallback)((acceptedFiles) => {
        setFile(acceptedFiles[0]);
    }, []);
    const { getRootProps, getInputProps, isDragActive, fileRejections, acceptedFiles } = (0, react_dropzone_1.useDropzone)({
        onDrop,
        accept: global_variables_1.ACCEPTED_IMPORT_IMAGE_TYPES,
        maxSize: MAX_FILE_SIZE_BYTES,
        getFilesFromEvent: async (event) => getFilesWithResolution(event),
        validator: (file) => customImageRsolutionValidation(file, maxPhotoDimensions ? maxPhotoDimensions.width : undefined, maxPhotoDimensions ? maxPhotoDimensions.height : undefined),
    });
    const clearDropzone = () => {
        // Create mutable copies of the readonly arrays
        const mutableAcceptedFiles = [...acceptedFiles];
        const mutableFileRejections = [...fileRejections];
        // Clear the arrays by emptying their copies
        mutableAcceptedFiles.length = 0;
        mutableFileRejections.length = 0;
        // Reset state
        setScale(1);
    };
    const width = dropzoneDimensions ? dropzoneDimensions.width : DEFAULT_DROPZONE_WIDTH;
    const height = dropzoneDimensions ? dropzoneDimensions.height : DEFAULT_DROPZONE_HEIGHT;
    return ((0, jsx_runtime_1.jsx)(Modal_1.Modal, { header: modalTitle || formatMessage({ id: messages_1.AppMessages['addPhoto.title'] }), open: open, onClose: async () => {
            clearOnClose && setFile(undefined);
            clearDropzone();
            onClose();
        }, type: "form", onSubmit: () => {
            const canvas = editor?.current?.getImage();
            if (file) {
                canvas?.toBlob((blob) => blob && onSubmit(blob));
                clearOnClose && setTimeout(() => setFile(undefined), 2000);
            }
            else {
                onSubmit(undefined);
            }
        }, submitButtonText: submitButtonText, children: (0, jsx_runtime_1.jsx)(Styled.DropzoneWrapper, { children: file ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Styled.Dropzone, { "$isDragActive": true, "$isError": false, "$width": width, "$height": height, children: [(0, jsx_runtime_1.jsx)(Styled.RemoveButton, { variant: "contained", disableElevation: true, onClick: () => setFile(undefined), children: (0, jsx_runtime_1.jsx)(RemovePhotoTrashIcon_1.RemovePhotoTrashIcon, {}) }), (0, jsx_runtime_1.jsx)(react_avatar_editor_1.default, { image: file, width: width, height: height, border: 0, scale: scale, ref: editor })] }), (0, jsx_runtime_1.jsxs)(Styled.SlderWrapper, { children: [(0, jsx_runtime_1.jsx)(material_1.IconButton, { onClick: () => scale > MIN_SCALE && setScale(scale - STEP_SCALE * 10), children: (0, jsx_runtime_1.jsx)(ZoomOutIcon_1.ZoomOutIcon, {}) }), (0, jsx_runtime_1.jsx)(Styled.Slider, { value: scale, min: MIN_SCALE, max: MAX_SCALE, step: STEP_SCALE, onChange: (_e, value) => setScale(value), size: "small" }), (0, jsx_runtime_1.jsx)(material_1.IconButton, { onClick: () => scale <= MAX_SCALE && setScale(scale + STEP_SCALE * 10), children: (0, jsx_runtime_1.jsx)(ZoomInIcon_1.ZoomInIcon, {}) })] })] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Styled.Dropzone, { ...getRootProps(), "$isDragActive": isDragActive, "$isError": !!fileRejections.length, "$width": width, "$height": height, children: [(0, jsx_runtime_1.jsx)("input", { ...getInputProps() }), (0, jsx_runtime_1.jsxs)(Styled.UploadTextWrapper, { children: [(0, jsx_runtime_1.jsx)(Styled.UploadText, { children: formatMessage({ id: messages_1.AppMessages['addPhoto.dropzone.dropText'] }) }), (0, jsx_runtime_1.jsx)(Styled.UploadTextButton, { children: formatMessage({ id: messages_1.AppMessages['addPhoto.dropzone.buttonText'] }) }), dropzoneDescription ? (dropzoneDescription()) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Styled.UploadSubText, { children: formatMessage({ id: messages_1.AppMessages['addPhoto.dropzone.formats'] }) }), (0, jsx_runtime_1.jsx)(Styled.UploadSubText, { children: formatMessage({ id: messages_1.AppMessages['addPhoto.dropzone.resolution'] }) }), (0, jsx_runtime_1.jsx)(Styled.UploadSubText, { children: formatMessage({ id: messages_1.AppMessages['addPhoto.dropzone.size'] }) })] }))] })] }), (0, jsx_runtime_1.jsx)(Styled.ValidationWrapper, { children: !!fileRejections.length &&
                            (fileRejections[0].errors[0].code === 'file-too-large' ? ((0, jsx_runtime_1.jsx)(Styled.FilesValidationText, { variant: "subtitle2", "$width": width, "$errorAlignedLeft": errorAlignedLeft, children: formatMessage({ id: messages_1.AppMessages['addPhoto.invalidSize'] }) })) : fileRejections[0].errors[0].code === 'invalid-resolution' ? ((0, jsx_runtime_1.jsx)(Styled.FilesValidationText, { variant: "subtitle2", "$width": width, "$errorAlignedLeft": errorAlignedLeft, children: formatMessage({ id: messages_1.AppMessages['addPhoto.invalidResolution'] }) })) : ((0, jsx_runtime_1.jsx)(Styled.FilesValidationText, { variant: "subtitle2", "$width": width, "$errorAlignedLeft": errorAlignedLeft, children: formatMessage({ id: messages_1.AppMessages['addPhoto.invalidFile'] }) }))) })] })) }) }));
};
exports.AddPhotoModal = AddPhotoModal;
